import styled from 'styled-components';

export const StyledColumnChart = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  overflow: visible;

  & aside {
    width: 2%;
    margin-bottom: 4rem;
  }
`;

export const StyledChartWrapper = styled.main`
  width: 80%;
  display: flex;
  overflow: visible;

  & [data-highcharts-chart],
  & .highcharts-container {
    overflow: visible !important;
  }
  & .highcharts-plot-line-label {
    transform: rotate(0deg) translate(-12px, -20px) !important;
  }
`;
